"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _secondaryMarketingPosition = require("@/api/operationManagement/secondaryMarketingPosition");
var _activeBinding = require("@/api/activeBinding");
var _secondaryMarketing = _interopRequireDefault(require("./components/secondaryMarketing"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PopupManagement',
  components: {
    secondaryMarketing: _secondaryMarketing.default
  },
  data: function data() {
    return {
      loading: false,
      pagination: {
        total: 0 // 条数
      },
      queryData: {
        locationCode: '',
        enable: null,
        pageParam: {
          page: 1,
          size: 10
        }
      },
      tableData: [],
      marketingBitList: []
    };
  },
  created: function created() {
    this.marketingList();
    this.getBusinessCollege();
  },
  methods: {
    onInquire: function onInquire() {
      this.queryData.pageParam.page = 1;
      this.queryData.pageParam.size = 10;
      this.marketingList();
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        region: '',
        enable: '',
        pageParam: {
          page: 1,
          size: 10
        }
      };
      this.marketingList();
    },
    onAddPopup: function onAddPopup() {
      this.$refs.secondaryMarketing.open({
        type: 'add',
        name: '设置模块信息'
      });
    },
    onDetail: function onDetail(data) {
      this.$refs.secondaryMarketing.open({
        type: 'editor',
        name: '设置模块信息',
        id: data.id
      });
    },
    // 删除
    onDel: function onDel(data) {
      var _this = this;
      this.$confirm('是否确认删除此弹窗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.unbindMarketingPosition(data.id, data.modelId);
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.pageParam.size = val;
      this.marketingList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.pageParam.page = val;
      this.marketingList();
    },
    onRefresh: function onRefresh() {
      this.queryData.pageParam.page = 1;
      this.queryData.pageParam.size = 10;
      this.marketingList();
    },
    marketingList: function () {
      var _marketingList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.loading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _secondaryMarketingPosition.marketingList)(params);
            case 1:
              res = _context.v;
              this.loading = false;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.pagination.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.loading = false;
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function marketingList() {
        return _marketingList2.apply(this, arguments);
      }
      return marketingList;
    }(),
    unbindMarketingPosition: function () {
      var _unbindMarketingPosition2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(id, modelId) {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                id: id,
                modelId: modelId
              };
              _context2.n = 1;
              return (0, _activeBinding.unbindMarketingPosition)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
              }
              this.marketingList();
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function unbindMarketingPosition(_x, _x2) {
        return _unbindMarketingPosition2.apply(this, arguments);
      }
      return unbindMarketingPosition;
    }(),
    // 配置信息
    getBusinessCollege: function () {
      var _getBusinessCollege2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                category: 16
              };
              _context3.n = 1;
              return (0, _secondaryMarketingPosition.getBusinessCollege)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.marketingBitList = res.data;
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getBusinessCollege() {
        return _getBusinessCollege2.apply(this, arguments);
      }
      return getBusinessCollege;
    }()
  }
};